<template lang='pug'>
    v-hover(v-if="ready")
        template(v-slot:default="{ hover }")
            v-card.UX-agents-card.agents-card-width-height( :class="[hover ? 'UX-agents-card-hover' : '', allow_click ? 'cursor-pointer' : 'cursor-default']" :ripple="false" style="border-radius: 16px;" @click="handleClick")
                // Agent 名稱列
                v-card-title.pa-0.mx-4.my-2.justify-space-between.flex-nowrap
                    div.pa-0.ma-0.d-flex.align-center.justify-start
                        v-img(:src="select_icon_obj.path" max-width="36" style="margin:6px 6px 4px 0px;")
                        p.ma-0.agents-card-title(:title="agentCardData.agent_name") {{agentCardData.agent_name}}
                    div.align-center(v-if='showMoreBTN')
                        v-menu(offset-y bottom close-on-content-click)
                            template(v-slot:activator="{ on, attrs }")
                                v-btn(icon='icon' v-bind="attrs" v-on="on")
                                    v-img.img-mobile-size( src="@/assets/images/mdi--dots-horizontal.svg")
                            v-list()
                                v-list-item(@click="onEdit(agentCardData)")
                                    v-img.mr-4(src="@/assets/images/edit.png" max-height="20" max-width="20")
                                    span {{$t("GENERAL.EDIT")}}
                                v-list-item(@click="onDelete(agentCardData)" v-if="showDeleteBTN")
                                    v-icon.mr-2(size='18' color='#444') icon-remove
                                    span {{$t("GENERAL.DELETE")}}
                // Agent 描述列
                v-card-text.py-0.agents-card-text(style='height:60px; max-height: 60px;')
                    p.ma-0(:title="agentCardData.goal" style='font-size: 12px;') {{agentCardData.goal}}
                // 工具列
                div(v-if="$route.path.includes('/Agents')" style='width:298px; height:28px').mt-2.mx-auto.pa-0.d-flex.align-center.justify-start
                    // 開關知識庫
                    label.UX-switch.mr-1(@click.stop)
                        input(v-model='agentCardData.is_moving' type="checkbox" @click="updateAgent(agentCardData)")
                        div(class="UX-slider round")
                    span(v-if='agentCardData.is_moving' style='color:#888888; font-weight: 500; font-size: 14px;') {{$t("GPT_KNOWLEDGE.OPEN_LIB")}}
                    span(v-else style='color:#888888; font-weight: 500; font-size: 14px;') {{$t("GPT_KNOWLEDGE.CLOSE_LIB")}}
                v-divider.ma-0.mx-2.my-3(v-if="$vuetify.breakpoint.smAndUp")
                // Agent 資訊列
                div.mb-4.d-flex.align-center.justify-space-between(v-if="$vuetify.breakpoint.smAndUp")
                    v-card-text.pa-0.ma-0.ml-2(v-if='agentCardData.updated_by' style='width:150px; max-height: 42px;')
                        div.ma-0.d-flex.align-center.justify-start(:title='updatedByTitle')
                            span(style='color:#888888; font-weight: 400; font-size: 12px;') {{$t("GPT_KNOWLEDGE.UPDATED_BY")}} :  
                            span.updateby-user.pl-1(style='color:#666666; font-weight: 400; font-size: 12px;') {{updatedByName}}
                    v-card-text.pa-0.ma-0.ml-2(v-else style='width:150px; max-height: 42px;')
                        div.ma-0.d-flex.align-center.justify-start()
                            span(style='color:#888888; font-weight: 400; font-size: 12px;') {{$t("GPT_KNOWLEDGE.UPDATED_BY")}} :  
                            span.updateby-user.pl-1(style='color:#666666; font-weight: 400; font-size: 12px;') {{$t("AGENT.UN_UPDATED")}}
                    v-card-text.pa-0.ma-0(style='width:180px; max-height: 42px;')
                        div.pa-0.ma-0.d-flex.align-center.justify-start(v-if='KnowledgeLibs.length>0 && agentCardData.selection_mode == "knowledge_lib" && agentCardData.use_knowledge_lib')
                            p.mb-0(:title='KnowledgeLibs.length' style='color:#888888; font-weight: 400; font-size: 12px;') {{$t("AGENT.KNOWLEDGE_LIBS")}} : 
                                v-avatar.ma-0.pa-0.mr-1.knowledges-avatar-UX(v-for='(item,index) in KnowledgeLibs.slice(0, 5)' :key='index' :color="knowledge_lib_background_colors[index]" size='20' :title='item.knowledge_lib.name' v-if='index<3')
                                    div(style='color:#666666; font-weight: 500; font-size: 14px; margin-left: -0.5px; margin-bottom: 1px;') {{ item.knowledge_lib.name[0] }}
                            div.pa-0.ma-0(v-if='KnowledgeLibs.length>3' style='color:#666666; font-weight: 400; font-size: 12px;') +{{KnowledgeLibs.length - 3}}
                        div.pa-0.ma-0.d-flex.align-center.justify-start(v-if='KnowledgeFolder.length>0 && agentCardData.selection_mode == "knowledge_folder" && agentCardData.use_knowledge_lib')
                            p.mb-0(:title='KnowledgeFolder.length' style='color:#888888; font-weight: 400; font-size: 12px;') {{$t("KNOWLEDGE_FOLDER.folder")}} :
                                .d-flex.align-center.ml-1(
                                    v-for='(item,index) in KnowledgeFolder.slice(0, 3)'
                                    :key='`folder-${index}`'
                                    :title='getFolderName(item)'
                                    style='max-width: 120px;'
                                )
                                    v-img.mr-1(src="@/assets/images/folder-btn.svg" max-height="16" max-width="16")
                                    span.ellipsis-3(    :title="getFolderName(item)" style='color:#666666; font-weight: 400; font-size: 12px; ')
                                        | {{ getFolderName(item) }}
                                    div.pa-0.ma-0(v-if='KnowledgeFolder.length>3' style='color:#666666; font-weight: 400; font-size: 12px;')
                                        | +{{ KnowledgeFolder.length - 3 }}
</template>
<script>
import UpGPTPortalDataServices from "@/services/UpGPTPortalDataServices";

export default {
    name: 'AgentCard',
    props: {
        agentCardData: {
            type: Object,
            require:true,
        },
        user_mode: {
            type: Boolean,
            required: false,
            default: false
        },
        allow_click: {
            type: Boolean,
            required: false,
        },
        // allKnowledgeColor: {
        //     type: Array,
        //     required:true,
        // },
    },
    created(){
        if (this.agentCardData && this.agentCardData.icon_path){
            this.select_icon_obj = { name: this.agentCardData.icon_path, path: this.mapping_icon_path(this.agentCardData.icon_path) }
        } else {
            this.select_icon_obj = { name: "default", path: require("@/assets/images/agent_icon/default.png") }
        }
    },
    data() {
        return{
            knowledge_lib_background_colors: ['#9ACFFF', '#F6C2C2', '#DEC5F6', '#9ACFFF', '#F6C2C2', '#DEC5F6' ],
            select_icon_obj: { name: "default", path: require("@/assets/images/agent_icon/default.png") },
        }
    },
    methods: {
        async updateAgent(data){
            let edit_data = {
                "id" : data.id,
                "is_moving" : !data.is_moving
            }
            await UpGPTPortalDataServices.updateAgentStatus(edit_data).then(response=>{
                data.is_moving = response.data.is_moving;
            })
        },
        onEdit(agentCardData){
            if(this.user_mode){
                // portal page
                this.$emit("emitEditAgentCard",agentCardData);
            }else{
                // console page
                this.$emit('openSelectDrawer', this.agentCardData);
            }
        },
        onDelete(agentCardData){
            this.$emit("emitDeleteAgent",agentCardData);
        },
        handleClick() {
            if (!this.user_mode && this.allow_click) {
                // Console page click Advance agent drawer
                if (this.agentCardData.agent_style == "simple" && this.agentCardData.linked_agents_and_knowledge_set){
                    let kb_arr = this.agentCardData.linked_agents_and_knowledge_set.map(item=> {return item.knowledge_lib})
                    this.$set(this.agentCardData, 'knowledges', kb_arr)
                }
                this.$emit('openSelectDrawer', this.agentCardData);
            }
            else if(this.user_mode && this.allow_click){
                // Portal page click
                if(this.agentCardData.agent_style == "simple"){
                   // simple agent tag
                   this.$emit('applyAgent', this.agentCardData);
                   // console.log('在portal 點擊 simple agent AGent Card Applyagent', this.agentCardData)
                }else{
                    // advance agent drawer
                    this.$emit('openSelectDrawer', this.agentCardData);
                }
            }
        },
        mapping_icon_path(icon_name){
            if (icon_name == 'award') {
                return require("@/assets/images/agent_icon/award.png")
            } else if (icon_name == 'cloud'){
                return require("@/assets/images/agent_icon/cloud.png")
            } else if (icon_name == 'construction'){
                return require("@/assets/images/agent_icon/construction.png")
            } else if (icon_name == 'customerservice'){
                return require("@/assets/images/agent_icon/customerservice.png")
            } else if (icon_name == 'finance'){
                return require("@/assets/images/agent_icon/finance.png")
            } else if (icon_name == 'generate'){
                return require("@/assets/images/agent_icon/generate.png")
            } else if (icon_name == 'humanresource'){
                return require("@/assets/images/agent_icon/humanresource.png")
            } else if (icon_name == 'idea'){
                return require("@/assets/images/agent_icon/idea.png")
            } else if (icon_name == 'knowledge'){
                return require("@/assets/images/agent_icon/knowledge.png")
            } else if (icon_name == 'message'){
                return require("@/assets/images/agent_icon/message.png")
            } else if (icon_name == 'metal'){
                return require("@/assets/images/agent_icon/metal.png")
            } else if (icon_name == 'policy'){
                return require("@/assets/images/agent_icon/policy.png")
            } else if (icon_name == 'questionandanswer'){
                return require("@/assets/images/agent_icon/questionandanswer.png")
            } else if (icon_name == 'report'){
                return require("@/assets/images/agent_icon/report.png")
            } else if (icon_name == 'robot'){
                return require("@/assets/images/agent_icon/robot.png")
            } else if (icon_name == 'searchimage'){
                return require("@/assets/images/agent_icon/searchimage.png")
            } else if (icon_name == 'setting'){
                return require("@/assets/images/agent_icon/setting.png")
            } else if (icon_name == 'shopping_cart'){
                return require("@/assets/images/agent_icon/shopping_cart.png")
            } else if (icon_name == 'speclist'){
                return require("@/assets/images/agent_icon/speclist.png")
            } else if (icon_name == 'translate'){
                return require("@/assets/images/agent_icon/translate.png")
            } else if (icon_name == 'conversation'){
                return require("@/assets/images/agent_icon/conversation.png")
            } else if (icon_name == 'record'){
                return require("@/assets/images/agent_icon/record.png")
            } else if (icon_name == 'target'){
                return require("@/assets/images/agent_icon/target.png")
            } else if (icon_name == 'house'){
                return require("@/assets/images/agent_icon/house.png")
            } else if (icon_name == 'land_property'){
                return require("@/assets/images/agent_icon/land_property.png")
            } else if (icon_name == 'mail_reply'){
                return require("@/assets/images/agent_icon/mail_reply.png")
            } else if (icon_name == 'search_web'){
                return require("@/assets/images/agent_icon/search_web.png")
            } else {
                return require("@/assets/images/agent_icon/default.png")
            }
        },
        getFolderName(item) {
            const name = item?.knowledge_folder?.name ||
                item?.folder?.name ||
                item?.name ||
                "";
            return name;
        }
    },
    computed: {
        ready (){
            return !!(this.agentCardData && Object.keys(this.agentCardData).length);
        },
        updatedByName (){
            const u = this.agentCardData?.updated_by;
            return u ? `${u.last_name} ${u.first_name}` : '';
        },
        updatedByTitle(){
            const u = this.agentCardData?.updated_by;
            return u ? `${u.last_name} ${u.first_name}` : '';
        },
        KnowledgeLibs (){
            const d = this.agentCardData || {};
            if (this.user_mode) {
                return d.linked_useragents_and_knowledge_set || [];
            }
            return d.linked_agents_and_knowledge_set || [];
        },
        KnowledgeFolder (){
            const d = this.agentCardData || {};
            if (this.user_mode) {
                return d.linked_useragents_and_knowledge_folder_set || [];
            }
            return d.linked_agents_and_knowledge_folder_set || [];
        },
        // knowledge_lib_background_colors () {
        //     // 確保有顏色陣列，不然 v-avatar 綁定會報錯
        //     return ['#F4F4F5', '#E5E7EB', '#EDE9FE', '#DBEAFE', '#DCFCE7'];
        // },
        showMoreBTN(){
            return (this.agentCardData.agent_style == "simple" ) ? true : false;
        },
        showDeleteBTN(){
            return (this.agentCardData.agent_style == "simple" ) ? true : false; 
            // return (this.agentCardData.agent_style == "simple" && this.user_mode == false )  ||
            // (this.agentCardData.agent_style === "simple" && this.agentCardData.is_private == true);
        },

    },
    watch:{
        "agentCardData.icon_path":function(e){
            if (e){
                this.select_icon_obj = { name: e, path: this.mapping_icon_path(e) }
            } else {
                this.select_icon_obj = { name: "default", path: require("@/assets/images/agent_icon/default.png") }
            }
        },
    }
}
</script>
<style scoped lang="css">
    .cursor-pointer {
    cursor: pointer;
    }
    .cursor-default {
    cursor: default;
    }
    .ellipsis-3 {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 100%;
    }
</style>